<template>
  <div v-if="game" class="nextgame">
    <div class="mt-2">
      <font-awesome-icon icon="futbol" class="fa-fw" />Volgende wedstrijd
    </div>
    <div v-if="game.number" class="mt-2">
      <small>Nr. {{game.number}}</small>
    </div>
    <table class="table table-condensed table-borderless">
      <tr>
        <td colspan="3">
          <small>
            {{ game.date | formatDayName }} {{ game.date | formatDate }} om {{game.date | formatTime}}
            <span
              v-if="game.location"
            >@ {{game.location}}</span>
          </small>
        </td>
      </tr>
      <tr>
        <td>{{game.homeTeam}} ({{game.homeRank}})</td>
        <td>vs.</td>
        <td>{{game.outTeam}} ({{game.outRank}})</td>
      </tr>
    </table>
    <div ref="chart" class="chart"></div>
  </div>
</template>

<script>
import ApexCharts from "apexcharts";
export default {
  name: "NextGame",
  props: {
    data: Array
  },
  data: function() {
    return {
      game: Object
    };
  },
  created: function() {
    this.game = this.data.find(g => !g.isPassed);
  },
  mounted: function() {
    var options = {
      chart: {
        height: 200,
        type: "line",
        zoom: {
          enabled: false
        },
        toolbar: {
          tools: {
            download: false
          }
        }
      },
      series: [
        {
          name: this.game.homeTeam,
          data: this.game.homePointHistory
        },
        {
          name: this.game.outTeam,
          data: this.game.outPointHistory
        }
      ],
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: "straight"
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5
        }
      }
      // xaxis: {
      //   title: {
      //     text: "speeldag"
      //   }
      // },
      // yaxis: {
      //   title: {
      //     text: "punten"
      //   }
      // }
    };

    var chart = new ApexCharts(this.$refs.chart, options);

    chart.render();
  }
};
</script>

<style scoped>
.chart {
  align-items: center;
  margin-right: 2em;
}
</style>
